module.exports = __webpack_public_path__ + "static/img/page5-record.a789e16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/listen-report/page5-record.png
// module id = tfd3
// module chunks = 216